import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { useTranslation } from '@/hooks/useTranslation';

export default function CustCompleted() {
  const { t } = useTranslation();

  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 inset-x-0 top-[26%] flex flex-col items-stretch">
        <SurveyContentPanelInset>
          <SurveyContentPanel className="flex min-h-[20.48rem] flex-col justify-center !py-[2.7rem] sm:min-h-[21.56rem]">
            <div className="mx-auto w-[95%]">
              <p className="m-0 leading-[1.75]">
                <span className="block">{t.custCompleted.line1}</span>
                <span className="block">{t.custCompleted.line2}</span>
                <span className="block">{t.custCompleted.line3}</span>
              </p>
            </div>
          </SurveyContentPanel>
        </SurveyContentPanelInset>
      </div>
    </SurveyBackgroundLayout>
  );
}
